import { BRANDED_FIXTURES_STATE_KEY } from './branded-fixtures-reducer';

export const getSearch = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].search;
export const getSorting = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].sorting;

export const getBrandedFixtureById = (state: any, id: string) =>
  state[BRANDED_FIXTURES_STATE_KEY].brandedFixture.contents.find((fixture: any) => fixture.id === id);

export const getBrandedFixturesForGrid = (state: any) =>
  state[BRANDED_FIXTURES_STATE_KEY]?.brandedFixture?.contents?.map(({ id, ...rest }: any, idx: number) => {
    const boardCapacity = rest.boardCapacity ?? rest.board_capacity ?? rest.capacity;

    return {
      key: `${id}-${idx}`,
      id: id,
      ...rest,
      boardCapacity,
      board_capacity: boardCapacity,
      capacity: boardCapacity,
    };
  });

export const getTotal = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].brandedFixture.total;
export const getLoading = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].loading;
export const getDetailsLoading = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].detailsLoading;
export const getAllBrandedFixtures = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].brandedFixtureDetails;
export const getActiveBrandedFixtures = (state: any) =>
  state[BRANDED_FIXTURES_STATE_KEY].brandedFixtureDetails?.filter((fixture: any) => fixture.isInactive === false);

export const getCollections = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].collections;
export const getCollectionsLoading = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].collectionsLoading;

export const getVendorCollectionListings = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].vendorCollectionListings;
export const getVendorCollectionListingsLoading = (state: any) =>
  state[BRANDED_FIXTURES_STATE_KEY].vendorCollectionListingsLoading;
export const getOfficeFixtures = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].officeFixtures || [];
export const getOfficeFixturesLoading = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].officeFixturesLoading;
export const getDefaultOfficeBrandedFixtures = (state: any) =>
  state[BRANDED_FIXTURES_STATE_KEY].defaultOfficeBrandedFixtures || [];
export const getDefaultOfficeBrandedFixturesLoading = (state: any) =>
  state[BRANDED_FIXTURES_STATE_KEY].defaultOfficeBrandedFixturesLoading;
export const getOfficeFixturesSaving = (state: any) => state[BRANDED_FIXTURES_STATE_KEY].officeFixturesSaving;

// Get unique vendors from vendor-collection listings
export const getUniqueVendors = (state: any) => {
  const listings = state[BRANDED_FIXTURES_STATE_KEY].vendorCollectionListings || [];
  const uniqueVendorsMap = new Map<number, { acuityVendorID: number; vendorName: string }>();

  listings.forEach((item: any) => {
    if (item.acuityVendorID && item.vendorName && !uniqueVendorsMap.has(item.acuityVendorID)) {
      uniqueVendorsMap.set(item.acuityVendorID, {
        acuityVendorID: item.acuityVendorID,
        vendorName: item.vendorName,
      });
    }
  });

  return Array.from(uniqueVendorsMap.values()).sort((a, b) => a.vendorName.localeCompare(b.vendorName));
};

// Get collections filtered by vendor ID
export const getCollectionsByVendorId = (state: any, acuityVendorID: number) => {
  const listings = state[BRANDED_FIXTURES_STATE_KEY].vendorCollectionListings || [];
  return listings
    .filter((item: any) => item.acuityVendorID === acuityVendorID && item.collectionName)
    .map((item: any) => ({
      acuityCollectionID: item.acuityCollectionID,
      collectionName: item.collectionName,
      databaseCollectionID: item.databaseCollectionID,
      collectionType: item.collectionType,
      notes: item.notes,
    }))
    .sort((a: any, b: any) => (a.collectionName || '').localeCompare(b.collectionName || ''));
};
